import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
            extend: true,
        }),
    ],
    exports: [TranslateModule],
})
export class TranslationModule {
    constructor(
        private translate: TranslateService,
        private route: ActivatedRoute,
    ) {
        // Set up language only once on initial load
        this.route.queryParamMap.subscribe((params) => {
            const lang = params.get('lang') || 'id';

            // Only change language if it's different from current
            if (this.translate.currentLang !== lang) {
                this.translate.setDefaultLang(lang);
                this.translate.use(lang);
            }
        });
    }
}
